// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6804":"4fba13f1","7578":"7490edb4"}[chunkId] + ".chunk.css";
};